{
    "SectionheaderReportoptions": "Rapportopties",
    "ReporttablabelStyle": "Stijl:",
    "ReporttablabelName": "Naam:",
    "ReporttablabelFolder": "Map:",
    "ReporttablabelNote": "Opmerking:",
    "ReporttabReportnameoverwritePromptTextFormatString": "U heeft de rapportstijl van dit rapport gewijzigd - Wilt u de bestaande naam van het rapport automatisch overschrijven met '|1'?",
    "NAME": "ReportOptions",
    "ReporttablabelInterval": "Interval:"
}